import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import PAGES from "@/seo/pages.json";
import { useLang } from "@/i18n";

// Internal links between tool variants and guides of the same tool (helps crawling and users)
export const RelatedLinks = ({ tool, current }) => {
  const { t, lang } = useLang();
  const items = Object.entries(PAGES).filter(([k, p]) => p.tool === tool && k !== current);
  if (!items.length) return null;
  return (
    <section className="mt-14 max-w-3xl" data-testid="related-links">
      <h2 className="text-lg font-semibold text-slate-900">{t("faq.related")}</h2>
      <ul className="mt-4 grid gap-2 sm:grid-cols-2">
        {items.map(([k, p]) => (
          <li key={k}>
            <Link to={p.paths[lang]} data-testid={`related-${k}`} className="group flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 hover:border-slate-900">
              {p.type === "guide" && <BookOpen className="h-4 w-4 shrink-0 text-[#00A3E0]" />}
              <span className="flex-1">{p[lang].h1}</span>
              <ArrowRight className="h-4 w-4 text-slate-400 transition-transform group-hover:translate-x-1" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
